<template>
  <!--<q-virtual-scroll-->
  <!--  type="table"-->
  <!--  style="max-height: 70vh"-->
  <!--  :virtual-scroll-item-size="48"-->
  <!--  :virtual-scroll-sticky-size-start="48"-->
  <!--  :virtual-scroll-sticky-size-end="32"-->
  <!--  :items="data"-->
  <!--&gt;-->
  <!--  <template v-slot:before>-->
  <!--    <thead class="thead-sticky text-left">-->
  <!--      &lt;!&ndash;<tr>&ndash;&gt;-->
  <!--      &lt;!&ndash;  <th class="">{{ $t('Type/Region') }}</th>&ndash;&gt;-->
  <!--      &lt;!&ndash;  <th class="text-right">{{ $t('Usage Quantity') }}</th>&ndash;&gt;-->
  <!--      &lt;!&ndash;  <th class="text-right">{{ $t('Total Charge') }}</th>&ndash;&gt;-->
  <!--      &lt;!&ndash;</tr>&ndash;&gt;-->
  <!--      <tr>-->
  <!--        <th v-for="col in columns" :key="col.prop">-->
  <!--          {{ col.name }}-->
  <!--        </th>-->
  <!--      </tr>-->
  <!--    </thead>-->
  <!--  </template>-->

  <!--  <template v-slot="{ item: row, index }">-->
  <!--    <tr :key="index">-->
  <!--      <td v-for="col in columns" :key="index + '-' + col.name">-->
  <!--        {{ row[col.prop] }}-->
  <!--      </td>-->
  <!--    </tr>-->
  <!--  </template>-->

  <!--  <template v-slot="{ item: row, index }">-->
  <!--    <tr class="region-row" :key="`details-${index}`">-->
  <!--      <td colspan="3">{{ value.region | regionAws }}</td>-->
  <!--    </tr>-->
  <!--    <tr-->
  <!--      class="usage-row"-->
  <!--      v-for="(detail, i) in value.data"-->
  <!--      :key="`${value['region']}-detail-${i}`"-->
  <!--    >-->
  <!--      <td>-->
  <!--        <template v-if="detail['instance_type']">{{ detail['instance_type'] }}</template>-->
  <!--        <template v-else>{{ detail['usage_type'] }}</template>-->

  <!--        <div-->
  <!--          class="description"-->
  <!--          v-html="convertDescription(detail.description)"-->
  <!--          v-if="detail.description"-->
  <!--        ></div>-->
  <!--        <div class="description" v-else="">{{ detail.operation }}</div>-->
  <!--      </td>-->
  <!--      <td>-->
  <!--        <Amount :value="detail.usage_quantity" :tooltip="detail.usage_quantity"></Amount>-->
  <!--      </td>-->
  <!--      <td>-->
  <!--        <CCurrency-->
  <!--          :value="detail.cost"-->
  <!--          :tooltip="`${currencySymbol(currencyType())}${detail.cost}`"-->
  <!--          :type="currencyType()"-->
  <!--        />-->
  <!--      </td>-->
  <!--    </tr>-->
  <!--  </template>-->
  <!--</q-virtual-scroll>-->

  <table class="report-table">
    <thead>
      <tr>
        <th class="">{{ $t('Type/Region') }}</th>
        <th class="text-right">{{ $t('Usage Quantity') }}</th>
        <th class="text-right">{{ $t('Total Charge') }}</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(value, index) in data">
        <tr class="region-row" :key="`details-${index}`">
          <td colspan="3">{{ value.region | regionAws }}</td>
        </tr>
        <tr
          class="usage-row"
          v-for="(detail, i) in value.data"
          :key="`${value['region']}-detail-${i}`"
        >
          <td>
            <template v-if="detail['instance_type']">{{ detail['instance_type'] }}</template>
            <template v-else>{{ detail['usage_type'] }}</template>

            <div
              class="description"
              v-html="convertDescription(detail.description)"
              v-if="detail.description"
            ></div>
            <div class="description" v-else>{{ detail.operation }}</div>
          </td>
          <td>
            <Amount :value="detail.usage_quantity" :tooltip="detail.usage_quantity"></Amount>
          </td>
          <td>
            <CCurrency
              :value="detail.cost"
              :tooltip="`${currencySymbol(currencyType())}${detail.cost}`"
              :type="currencyType()"
            />
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import { mapState } from 'vuex';
import Amount from '../uikit/Number';
import CCurrency from '@/components/uikit/CCurrency';

const messages = {
  en: {
    'Type/Region': 'Details',
    'Usage Quantity': 'Usage Quantity',
    'Total Charge': 'Total Charge',
  },
  ja: {
    'Type/Region': 'タイプ/リージョン',
    'Usage Quantity': '使用量',
    'Total Charge': '金額',
  },
};

export default {
  name: 'ReportBody',
  i18n: { messages: messages },
  components: { Amount, CCurrency },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      columns: [
        { name: this.$t('Type/Region'), prop: 'label' },
        { name: this.$t('Usage Quantity'), prop: 'quantity' },
        { name: this.$t('Total Charge'), prop: 'amount' },
      ],
    };
  },
  computed: {
    ...mapState({
      vendor: state => state.vendor,
    }),
  },
  methods: {
    currencyType() {
      return this.vendor === 'aws' ? 'usd' : 'jpy';
    },

    currencySymbol(currency) {
      switch (currency) {
        case 'usd':
          return '$';
        case 'jpy':
          return '¥';
        default:
          return '';
      }
    },

    convertDescription(text) {
      if (text) {
        if (text.indexOf('on-demand') !== -1) {
          const lifecycle = text.split('on-demand');
          return lifecycle[0] + '<strong>on-demand</strong>' + lifecycle[1];
        } else if (text.indexOf('Spot') !== -1) {
          const lifecycle = text.split('Spot');
          return lifecycle[0] + '<strong>spot</strong>' + lifecycle[1];
        } else if (text.indexOf('reserved') !== -1) {
          const lifecycle = text.split('reserved');
          return lifecycle[0] + '<strong>reserved</strong>' + lifecycle[1];
        }
        return text;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.report-table {
  width: 100%;
  margin-top: 2rem;
  font-size: 0.9rem;
}

th {
  font-size: 0.63rem;
  text-transform: uppercase;
  vertical-align: bottom;
  font-weight: 500;
  border-bottom: 1px solid $neutral-color;
  &:last-child {
    padding-left: 0.5rem;
  }
}

td {
  border-bottom: 1px solid $border-color;
  padding: 0.5rem 0;
}

.region-row {
  td {
    padding-top: 2rem;
    padding-bottom: 0;
    font-size: 1.1em;
    font-weight: 700;
    color: $primary-color;
    border: none;
  }
  &:first-child {
    td {
      padding-top: 0.5rem;
    }
  }
}

.usage-row {
  &:hover {
    background-color: rgba($neutral-color, 0.075);
  }
  td {
    text-align: right;
    &:first-child {
      text-align: left;
    }
    &:last-child {
      padding-left: 0.5rem;
    }
  }
}

.description {
  font-size: 0.8em;
  color: rgba($neutral-color, 0.7);
}
</style>
